import Paginate from 'vuejs-paginate'
import Vue from 'vue'
Vue.component('paginate', Paginate)
